import { render, staticRenderFns } from "./customer_address_detail.vue?vue&type=template&id=3e7a47d8&scoped=true"
import script from "./customer_address_detail.vue?vue&type=script&lang=js"
export * from "./customer_address_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7a47d8",
  null
  
)

export default component.exports